export const hideStyles = "hidden md:grid";